export const HEADER_FOOTER_ANALYTICS_KEY = 'shikdar_films_header_footer_analytics';

    const loadAnalytics = () => {
      try {
        const raw = localStorage.getItem(HEADER_FOOTER_ANALYTICS_KEY);
        return raw ? JSON.parse(raw) : { clicks: {} };
      } catch {
        return { clicks: {} };
      }
    };

    const saveAnalytics = (data) => {
      localStorage.setItem(HEADER_FOOTER_ANALYTICS_KEY, JSON.stringify(data));
    };

    /**
     * trackHeaderFooterClick
     * @param {'header'|'footer'} area
     * @param {string} elementId - stable id for item (e.g. `menu:home`, `footer:quickLink:about`)
     * @param {object} meta - { label, href, device }
     */
    export const trackHeaderFooterClick = (area, elementId, meta = {}) => {
      const analytics = loadAnalytics();
      const key = `${area}:${elementId}`;
      const now = new Date().toISOString();

      if (!analytics.clicks[key]) {
        analytics.clicks[key] = {
          area,
          elementId,
          label: meta.label || '',
          href: meta.href || '',
          device: {
            desktop: 0,
            tablet: 0,
            mobile: 0,
          },
          totalClicks: 0,
          firstClickAt: now,
          lastClickAt: now,
        };
      }

      const device = meta.device || 'desktop';
      if (!analytics.clicks[key].device[device]) {
        analytics.clicks[key].device[device] = 0;
      }

      analytics.clicks[key].device[device] += 1;
      analytics.clicks[key].totalClicks += 1;
      analytics.clicks[key].label = meta.label || analytics.clicks[key].label;
      analytics.clicks[key].href = meta.href || analytics.clicks[key].href;
      analytics.clicks[key].lastClickAt = now;

      saveAnalytics(analytics);
    };

    export const getHeaderFooterAnalytics = () => {
      const analytics = loadAnalytics();
      return Object.values(analytics.clicks || {}).sort(
        (a, b) => b.totalClicks - a.totalClicks
      );
    };

    export const clearHeaderFooterAnalytics = () => {
      saveAnalytics({ clicks: {} });
    };

    export const detectDeviceType = () => {
      if (typeof window === 'undefined') return 'desktop';
      const width = window.innerWidth || 1024;
      if (width < 640) return 'mobile';
      if (width < 1024) return 'tablet';
      return 'desktop';
    };